interface PhotoPanelProps {
  src: string;
  alt?: string;
  className?: string;
}

const PhotoPanel = ({ src, alt = '', className = '' }: PhotoPanelProps) => {
  return (
    <div className={`relative w-full h-full ${className}`}>
      <img src={src} alt={alt} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-primary-950/20 mix-blend-multiply" />
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/35 via-transparent to-transparent" />
    </div>
  );
};

export default PhotoPanel;
